export type ConstraintLevel =
  | 'Very high constraint'
  | 'High constraint'
  | 'Moderate constraint'
  | 'Low constraint'
  | 'No constraint'
  | 'No constraint data';

// [percentMin, percentMax) — value falls into category when min <= value < max
export const constraintScale: Record<ConstraintLevel, [number, number]> = {
  'No constraint data':              [ -10,  -1 ],
  'No constraint':                   [   0,   1 ],
  'Low constraint':                  [   1,  21 ],
  'Moderate constraint':             [  21,  41 ],
  'High constraint':                 [  41,  61 ],
  'Very high constraint':            [  61, 101 ]
};

export const getConstraintLevel = (value: number | null): ConstraintLevel | null => {
  if (value === null) return null;
  for (const [label, [min, max]] of Object.entries(constraintScale) as [ConstraintLevel, [number, number]][]) {
    if (value >= min && value < max) return label;
  }
  return null;
};
